import { render, staticRenderFns } from "./GetUserLiveData.vue?vue&type=template&id=82da0e7c&scoped=true&"
import script from "./GetUserLiveData.vue?vue&type=script&lang=js&"
export * from "./GetUserLiveData.vue?vue&type=script&lang=js&"
import style0 from "./GetUserLiveData.vue?vue&type=style&index=0&id=82da0e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da0e7c",
  null
  
)

export default component.exports